module.exports = __webpack_public_path__ + "images/emoji/dolls.5d8f95475e7c245776c5.png";